import { api, baseURL } from '../../shared/api/client';

/** Сведения об обследовании, открытом по ссылке из письма (без авторизации). */
export interface PublicShare {
  examinedAt: string; // YYYY-MM-DD
  modality: string;
  fileCount: number;
  totalSize: number;
  senderName: string;
  patientName: string;
  expiresAt: string;
}

export async function getPublicShare(token: string): Promise<PublicShare> {
  const { data } = await api.get<PublicShare>(`/v1/public/shares/${encodeURIComponent(token)}`);
  return data;
}

/** Прямая ссылка на ZIP: браузер качает сам (стрим, без буферизации в памяти). */
export function publicShareDownloadUrl(token: string): string {
  return `${baseURL}/v1/public/shares/${encodeURIComponent(token)}/download`;
}
